import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	iconContainer: {
		display: "flex",
		alignItems: "center",
		height: 30
	},
	tooltipIconWrapper: {
		display: "flex",
		alignItems: "center"
	}
})

export default useStyles
